module.exports = __webpack_public_path__ + "static/img/logo.03cf37c7.png";